import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { NavigationItems } from './NavigationItems';
import logo from '../../../assets/logo.png';

interface NavigationProps {
  items: { label: string; href: string }[];
}

const DesktopNavigation: React.FC<NavigationProps> = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/app/dashboard');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: 250,
        height: '100vh',
      }}
    >
      {/* Header with Logo and App Name */}
      <Box
        onClick={handleLogoClick}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          mt: 6,
          cursor: 'pointer',
          '&:hover': {
            opacity: 0.8,
          },
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="Lecturo Logo"
          sx={{
            maxWidth: 40,
            maxHeight: 40,
            mb: 1,
          }}
        />
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontWeight: 'bold',
            textAlign: 'center',
            fontSize: '1.25rem',
          }}
        >
          Lecturo
        </Typography>
      </Box>

      {/* Navigation Content */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          flex: 1,
          m: 2.5,
          mt: 1,
        }}
      >
        <NavigationItems variant="desktop" />
      </Box>
    </Box>
  );
};

export default DesktopNavigation;
